import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { Card, CardBody, Container } from 'reactstrap'
import evidenceDiary from '../../../../api/diaries/evidenceDiary/hooks'
import { EvidenceDiary } from '../../../../api/diaries/evidenceDiary/types'
import PageTitle from '../../../../Components/Common/PageTitle'
import { DataTableLayout, RenderRowProps, useDataTable, useTableState } from '../../../../Components/TanstackTable'
import { selectSearchCriteriaEvidenceDiaries } from '../../../../store/search'
import PrintDiaryTable from '../../PrintDiaryTable/PrintDiaryTable'
import { PrintTableProps } from '../../PrintDiaryTable/PrintDiaryTable.types'
import { useTableColumns } from './useTableColumns/useTableColumns'

const EvidenceDiaryList = () => {
    const history = useHistory()
    const { t } = useTranslation()

    const searchCriteria = useSelector(selectSearchCriteriaEvidenceDiaries)
    const tableState = useTableState({ tableKey: 'evidenceDiary' })

    const queryParams = { ...tableState.params, criteria: searchCriteria }

    const { data, isLoading } = evidenceDiary.GetDiaries.useQuery(queryParams, {
        enabled: Boolean(tableState.params.page && tableState.params.limit),
    })

    const items = useMemo(() => data?.items ?? [], [data?.items])
    const pageCount = data?.pagination?.totalPages ?? 0

    const renderRow = ({ row, children }: RenderRowProps<EvidenceDiary>) =>
        children({
            onClick: () => history.push(`/evidence-diary/${row.original.id}/edit`),
            style: { cursor: 'pointer' },
        })

    const columns = useTableColumns()

    const { table, updateColumnSizing } = useDataTable({
        ...tableState,
        columns,
        data: items,
        pageCount,
    })

    const tableActions = () => (
        <div className="d-flex flex-grow-1 justify-content-end">
            <PrintDiaryTable className="me-3" data={items} header={columns as PrintTableProps['header']} title={t('app.common.evidenceDiary')} />
        </div>
    )

    return (
        <div className="page-content">
            <Container fluid>
                <PageTitle title={t('app.common.evidenceDiary')} />
                <Card>
                    <CardBody>
                        <DataTableLayout
                            table={table}
                            isLoading={isLoading}
                            totalItems={data?.pagination?.totalItems ?? 0}
                            hasPageSizeSelect
                            theadClass="dmn-table-header"
                            toolbarActions={tableActions}
                            updateColumnSizing={updateColumnSizing}
                            renderRow={renderRow}
                        />
                    </CardBody>
                </Card>
            </Container>
        </div>
    )
}

export default EvidenceDiaryList
